// extracted by mini-css-extract-plugin
module.exports = {"root":"FullWidthHeightLoading_root__19jHF"};